
import request,{download} from '@/utils/request'


// 获取市场渠道列表
export function operationNoticeTypeList (data,params) {
    return request({
        url: 'contract/operationNoticeType/list',
        method: 'post',
        data,
        params,
        headers: { repeatSubmit: false },
    })
}

export function operationNoticeType (data) {
    return request({
        url: 'contract/operationNoticeType',
        method: 'put',
        data
    })
}

export function addNoticeType (data) {
    return request({
        url: 'contract/operationNoticeType',
        method: 'post',
        data
    })
}

export function deleteNoticeType (id) {
    return request({
        url: `contract/operationNoticeType/${id}`,
        method: 'delete',
    })
}

export function operationNoticeRoleList (params) {
    return request({
        url: `contract/operationNoticeRole/list`,
        method: 'get',
        // data,
        params,
        headers: { repeatSubmit: false },
    })
}
export function operationNoticeRoleListAll (params) {
    return request({
        url: `contract/operationNoticeRole/listAll`,
        method: 'get',
        // data,
        params,
        headers: { repeatSubmit: false },
    })
}


export function addNoticeRole (data) {
    return request({
        url: 'contract/operationNoticeRole',
        method: 'post',
        data
    })
}

export function operationNoticeRole (data) {
    return request({
        url: 'contract/operationNoticeRole',
        method: 'put',
        data,
        headers: { repeatSubmit: false },
    })
}

export function deleteNoticeRole (id) {
    return request({
        url: `contract/operationNoticeRole/${id}`,
        method: 'delete',
    })
}

export function operationNoticeUnReadCountApi(data) {
     return request({
        url: '/contract/operationNotice/unReadCount',
        method: 'post',
        data,
        headers: { repeatSubmit: false },
     })
}
export function myNoticeListApi(data,params) {
     return request({
        url: '/contract/operationNotice/myNoticeList',
        method: 'post',
        data,
        params,
        headers: { repeatSubmit: false },
     })
}


export function myNoticeDetailsApi(data) {
     return request({
        url: '/contract/operationNotice/myNoticeDetails',
        method: 'post',
        data
     })
}

export function addCommentApi(data) {
     return request({
        url: '/contract/operationNotice/addComment',
        method: 'post',
        data,
        headers: { repeatSubmit: false },
     })
}

// 文件上传
export function uploadFileApi(data) {
     return request({
        url: '/file/upload',
        method: 'post',
        data: data,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
     })
}
// 消息明细表

export function operationNoticeListApi(data,params) {
     return request({
        url: '/contract/operationNotice/detailList',
        method: 'post',
        data,
        params
     })
}
// 新增消息
export function addOperationNotice (data) {
    return request({
        url: 'contract/operationNotice',
        method: 'post',
        data
    })
}

// 消息统计表
export function noticeStatisticListApi (data) {
    return request({
        url: '/contract/operationNotice/noticeStatisticList',
        method: 'post',
        data
    })
}
// 查询角色
export function operationNoticeSelectUser (params) {
    return request({
        url: `contract/operationNotice/selectUser`,
        method: 'post',
        data: params,
        headers: { repeatSubmit: false },
    })
}

//统计导出
export function noticeStatisticListExportApi(query) {
    return download(
        `/contract/operationNotice/noticeStatisticListExport`,
        { ...query },
        `消息统计表_${new Date().getTime()}.xlsx`,
        { headers: { "Content-Type": "application/json" } }
    );
}


//删除
export function deleteNoticeByIdApi (id) {
    return request({
        url: `/contract/operationNotice/${id}`,
        method: 'delete',
    })
}
//消息明细表导出
export function detailListExportApi(query) {
    return download(
        `/contract/operationNotice/detailListExport`,
        { ...query },
        `消息明细表_${new Date().getTime()}.xlsx`,
        { headers: { "Content-Type": "application/json" } }
    );
}


//删除-明细
export function deleteDetailByIdApi (id) {
    return request({
        url: `/contract/operationNotice/delete`,
        method: 'post',
        data:{
            id
        }
    })
}

//撤回-明细
export function withdrawDetailByIdApi (id) {
    return request({
        url: `/contract/operationNotice/withdraw`,
        method: 'post',
        data:{
            id
        }
    })
}

//获取部门列表树结构(含用户)
export function deptTreeListApi () {
    return request({
        url: `/system/dept/deptTreeList`,
        method: 'get',
        params:{}
    })
}

//获取部门列表树结构(含用户) + V2 通用接口
const _deptTreeCache = new Map()
const _DEPT_TREE_CACHE_TTL = 60 * 1000

export async function deptTreeListApiV2 (data) {
  const cacheKey = JSON.stringify(data)
  const now = Date.now()
  const cached = _deptTreeCache.get(cacheKey)
  if (cached && now - cached.timestamp < _DEPT_TREE_CACHE_TTL) {
    return cached.promise
  }
  const promise = request({
    url: `/system/dept/tree/list`,
    method: 'post',
    params: data,
    headers: {repeatSubmit: false},
    data
  })
  _deptTreeCache.set(cacheKey, { promise, timestamp: now })
  return promise
}
